import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { TargetDomain } from 'data/targetDomain/targetDomain.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: TargetDomain,
  originalDigitExtractionServerFormData: TargetDomain | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.TARGET_DOMAIN_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.TARGET_DOMAIN_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.domain,
    AuditService.TARGET_DOMAIN,
    actionType,
  );
  return auditDetails as AuditDetails;
}
